
import React from 'react';
import Layout from './../../components/Layout/Layout';
import { Link } from 'react-router-dom';
export default function AddComment() {
  return (<>
    <Layout title="Review Documents"  pageTag={'account'} current={'/account/comments'}>
      <React.Fragment>
        <div className=" flex flex-col text-center bg-white "
        >        <div className="flex-1 flex flex-col p-8">
            <div className="flex">
              <img className="w-32 h-32 flex-shrink-0 mx-auto" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60" alt="" />
            </div>
            <Link to="/account/comments">
              <h3 className="mt-6 text-gray-900 text-sm ">Identity Card</h3>
            </Link>
          </div>

        </div>
        <div className='p-8'>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Comments
          </label>
          <div className="mt-1">
            <textarea
              rows="5"
              id="comments"
              className="shadow-sm  block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Start typing..."
            />
          </div>
          <div className='mt-4 flex justify-end'>
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
          >
            Send Comments
          </button>
        </div>
        </div>
       
      </React.Fragment>
    </Layout>

  </>);
}